import { BuyerLegalType } from "../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../auth/useLoggedInWithOrgContextState";

/**
 * Whether the current organization procures under the public procurement rules.
 *
 * This is a property of the organization, not of its subscription: it decides the vocabulary the
 * UI speaks and which regime a draft classifies into, so letting a billing flag answer it meant an
 * access change silently renamed the domain. Mirrors `Organization.runsPublicProcurements`.
 */
export const useRunsPublicProcurements = (): boolean => {
  const { buyerLegalType } = useLoggedInWithOrgContextState().selectedOrg;
  return !!buyerLegalType && buyerLegalType !== BuyerLegalType.Private;
};
